import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {UrlHelperService} from '@app/service/url-helper.service';
import {
	ConfigurationItemDetails,
	ConfigurationRequest,
	ConfigurationSummary,
	GuidedConfigurationPdf
} from '@app/model/configuration.model';
import {firstValueFrom, Observable} from 'rxjs';
import {BlobHelperService} from '@app/service/blob-helper.service';

@Injectable({
	providedIn: 'root'
})
export class ConfigurationService {

	constructor(private http: HttpClient,
							private urlHelper: UrlHelperService,
							private blobHelper: BlobHelperService) {
	}

	saveConfiguration(request: ConfigurationRequest): Observable<void> {
		const url = this.urlHelper.prepareApiPath('configurations');
		return this.http.post<void>(url, request);
	}

	async exportPdf(request: GuidedConfigurationPdf): Promise<void> {
		const url = this.urlHelper.prepareApiPath('configurations', 'pdf', 'guided');
		const headers = {'Content-Type': 'application/json', 'Accept': 'application/pdf'};
		const pdf = await firstValueFrom(this.http.post(url, request, {headers, responseType: 'blob'}));
		this.blobHelper.open(pdf);
	}

	deleteConfigurationById(id: number): Observable<void> {
		const url = this.urlHelper.prepareApiPath('configurations', `${id}`);
		return this.http.delete<void>(url);
	}

	getConfigurations(): Observable<ConfigurationSummary[]> {
		const url = this.urlHelper.prepareApiPath('configurations');
		return this.http.get<ConfigurationSummary[]>(url);
	}

	getConfigurationItems(id: number): Observable<ConfigurationItemDetails[]> {
		const url = this.urlHelper.prepareApiPath('configurations', `${id}`, 'items');
		return this.http.get<ConfigurationItemDetails[]>(url);
	}
}
